import * as FileSaver from "file-saver";
import * as XLSX from "sheetjs-style";
import exportIcon from "../../assets/icons/export.svg";

const ExportComments = ({ excelData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <button
      className="neutral"
      onClick={() => exportToExcel(fileName)}
    >
      <img src={exportIcon} alt="Export" className="w-4 h-4 inline-block mb-1 mr-1" />
      Export
    </button>
  );
}

export default ExportComments;
